// extracted by mini-css-extract-plugin
module.exports = {"sectionContainer":"quote_sectionContainer__NZHYd","quoteContainer":"quote_quoteContainer__3YK8A"};